import { setUserProvided } from '@components/bid_request/details/LineItemsTable/SmartBaselineBenchmarkRenderer/userProvidedStore';
import { Lot } from 'types';

/**
 * Uploaded-items flow, Step 4a (the fork). For every freshly-imported row that `createLineItem` already
 * flagged as buyer-provided (`is_buyer_provided_baseline_price`), record it in the in-session
 * `userProvidedStore` so the NSB seeder skips baselining it right away. This still has to run on the
 * client because a brand-new `new-` id row isn't known to the API yet — the mark must happen here,
 * synchronously in the reducer, before the grid first renders and before the first save/reload makes
 * the persisted column authoritative. Non-flagged rows are left alone → the existing NSB flow (4b) runs.
 *
 * It reads the flag `createLineItem` stamped (the single source of truth the backend also persists
 * write-once) rather than re-deriving it — it sets nothing else and never flips it.
 *
 * @param importedLots Lots staged by the OneSchema import (line items still carry `new-` ids).
 * @param eventId Current event id — the first half of the per-row sbKey (`${eventId}_${lineItemId}`).
 */
export const markUserProvidedBaselines = (
  importedLots: Lot[] | undefined,
  eventId: number | string | undefined,
): void => {
  if (!importedLots?.length || eventId === undefined) return;

  importedLots.forEach((lot: Lot): void => {
    lot.line_items.forEach((lineItem): void => {
      // The fork: the row createLineItem flagged as buyer-provided. Others fall through to NSB (4b).
      if (lineItem.is_buyer_provided_baseline_price) setUserProvided(`${eventId}_${lineItem.id}`);
    });
  });
};
